module.exports = __webpack_public_path__ + "static/media/fundo-qrpedir-min.9041b771.png";